<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-current">
    <path
      d="M12.65 8.4c-.02-2.02 1.65-3 1.72-3.04-0.94-1.37-2.4-1.56-2.92-1.58-1.24-.13-2.42.73-3.05.73-.63 0-1.6-.71-2.64-.69-1.36.02-2.61.79-3.31 2.01-1.41 2.45-.36 6.07 1.01 8.06.67.97 1.47 2.06 2.52 2.02 1.01-.04 1.39-.65 2.61-.65 1.22 0 1.56.65 2.63.63 1.09-.02 1.78-0.99 2.44-1.97.77-1.12 1.09-2.21 1.11-2.27-.02-.01-2.12-.81-2.14-3.25zM10.7 2.3c.56-.68.93-1.62.83-2.56-.8.03-1.77.53-2.34 1.2-.51.59-.96 1.54-.84 2.45.89.07 1.8-.45 2.35-1.09z"
    />
  </svg>
</template>

<script>
export default {};
</script>
